<template>
  <div
    v-if="version === 'v1'"
    class="tw-my-4 tw-flex tw-flex-row tw-items-center tw-justify-start tw-gap-5 tw-text-[16px]"
  >
    <div
      v-if="activePage !== 1"
      class="nc-icon-chevron-left n-cursor-pointer"
      style="color: #999999"
      @click="onClickedNavigationArrow(-1)"
    ></div>
    <div
      v-for="(page, index) in pages"
      :key="`pageNumber-${index}`"
      :class="activePage === page.id ? 'tw-border-b-2 tw-border-[var(--pagination-border-color)]' : ''"
    >
      <div v-if="page.is_clickable" class="n-cursor-pointer" @click="onClickedPage(page)">
        {{ page.title }}
      </div>
      <div v-else>
        {{ page.title }}
      </div>
    </div>
    <div
      v-if="activePage !== pageCount"
      class="nc-icon-chevron-right n-cursor-pointer"
      style="color: #999999"
      @click="onClickedNavigationArrow(1)"
    ></div>
  </div>

  <div
    v-if="version === 'v2'"
    class="scrollbar-hide pagination-container tw-my-10 tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-2 tw-overflow-x-auto max-lg:tw-pl-16 lg:tw-gap-4"
    style="max-width: 100%"
  >
    <div
      v-if="activePage !== 1"
      class="nc-icon-chevron-left n-cursor-pointer"
      @click="onClickedNavigationArrow(-1)"
    ></div>

    <div
      v-for="(page, index) in pages"
      :key="`pageNumber-${index}`"
      class="blog-pagination tw-flex tw-h-full tw-items-center tw-justify-center tw-whitespace-nowrap tw-border tw-px-4"
      style="border-radius: var(--rounded-input)"
      :style="
        activePage === page.id
          ? `color: white; background-color: ${paginationActiveBg}; `
          : `background-color: ${paginationBg};`
      "
      :class="activePage === page.id ? 'tw-border-[var(--pagination-border-color)]' : ''"
    >
      <div v-if="page.is_clickable" class="n-cursor-pointer tw-p-4" @click="onClickedPage(page)">
        {{ page.title }}
      </div>
      <div v-else class="n-cursor-pointer tw-p-4">
        {{ page.title }}
      </div>
    </div>

    <div
      v-if="activePage !== pageCount"
      class="nc-icon-chevron-right n-cursor-pointer"
      style="color: #999999"
      @click="onClickedNavigationArrow(1)"
    ></div>
  </div>

  <div
    v-if="version === 'v3'"
    class="pagination-container tw-my-10 tw-flex tw-w-full tw-flex-row tw-justify-center tw-gap-2 tw-overflow-x-auto tw-py-3 lg:tw-gap-3"
    style="font-family: var(--f-primary)"
  >
    <div
      v-if="activePage !== 1 && isPaginationArrow"
      class="n-cursor-pointer tw-p-3"
      :style="` border-radius: var(--rounded-input);`"
      @click="onClickedNavigationArrow(-1)"
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.3995 0.799988L11.5195 1.99999L5.59953 7.99999L11.5195 14L10.3995 15.2L3.19953 7.99999L10.3995 0.799988Z"
          fill="black"
        />
      </svg>
    </div>
    <div
      v-if="activePage !== 1 && !isPaginationArrow"
      class="n-cursor-pointer tw-p-3 lg:tw-px-5 lg:tw-py-4"
      :style="`background-color: ${paginationBg}; border-radius: var(--rounded-input);`"
      @click="onClickedNavigationArrow(-1)"
    >
      PREV
    </div>

    <div
      v-for="(page, index) in getPages(activePage)"
      :key="`pageNumber-${index}`"
      class="blog-pagination n-cursor-pointer tw-flex tw-items-center tw-justify-center tw-whitespace-nowrap tw-p-3 lg:tw-px-5 lg:tw-py-4"
      style="border-radius: var(--rounded-input)"
      :style="
        activePage === page.id
          ? `color: white; background-color: ${paginationActiveBg}; `
          : `background-color: ${paginationBg};`
      "
      @click="onClickedPage(page)"
      :class="activePage === page.id ? 'active-page tw-border-[var(--pagination-border-color)]' : ''"
    >
      <div v-if="page.is_clickable" class="n-cursor-pointer tw-w-6 tw-text-center" @click="onClickedPage(page)">
        {{ page.title }}
      </div>
      <div v-else class="tw-w-full tw-text-center">
        {{ page.title }}
      </div>
    </div>

    <div
      v-if="activePage !== pageCount && isPaginationArrow"
      class="n-cursor-pointer tw-p-3"
      style="color: #000"
      :style="`border-radius: var(--rounded-input);`"
      @click="onClickedNavigationArrow(1)"
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.60047 0.799988L4.48047 1.99999L10.4005 7.99999L4.48047 14L5.60047 15.2L12.8005 7.99999L5.60047 0.799988Z"
          fill="black"
        />
      </svg>
    </div>
    <div
      v-if="activePage !== pageCount && !isPaginationArrow"
      class="n-cursor-pointer tw-p-3 lg:tw-px-5 lg:tw-py-4"
      style="color: #000"
      :style="`background-color: ${paginationBg}; border-radius: var(--rounded-input);`"
      @click="onClickedNavigationArrow(1)"
    >
      NEXT
    </div>
  </div>

  <div
    v-if="version === 'v4'"
    class="tw-my-4 tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-3 tw-text-[16px] lg:tw-gap-5"
  >
    <div v-if="activePage !== 1" @click="onClickedNavigationArrow(-1)">
      <span
        ><svg width="61" height="28" viewBox="0 0 61 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10.4697 14.0303C10.1768 13.7374 10.1768 13.2626 10.4697 12.9697L15.2426 8.1967C15.5355 7.90381 16.0104 7.90381 16.3033 8.1967C16.5962 8.48959 16.5962 8.96447 16.3033 9.25736L12.0607 13.5L16.3033 17.7426C16.5962 18.0355 16.5962 18.5104 16.3033 18.8033C16.0104 19.0962 15.5355 19.0962 15.2426 18.8033L10.4697 14.0303ZM61 14.25H11V12.75H61V14.25Z"
            fill="#BFA87E"
          />
          <circle cx="13.5" cy="14" r="13" stroke="#BFA87E" stroke-opacity="0.5" />
        </svg>
      </span>
    </div>
    <div
      v-for="(page, index) in getPagesV2(activePage)"
      :key="`pageNumber-${index}`"
      :class="activePage === page.id ? 'tw-text-[var(--c-secondary)]' : ''"
    >
      <h5
        v-if="page.is_clickable"
        class="n-cursor-pointer tw-duration-300 hover:tw-text-[var(--c-secondary)]"
        style="letter-spacing: 0 !important; font-size: 20px !important"
        @click="onClickedPage(page)"
      >
        {{ page.title }}
      </h5>
      <h5
        v-else
        class="n-cursor-pointer tw-duration-300 hover:tw-text-[var(--c-secondary)]"
        style="letter-spacing: 0 !important; font-size: 20px !important"
      >
        {{ page.title }}
      </h5>
    </div>
    <div v-if="activePage !== pageCount" class="tw-cursor-pointer" @click="onClickedNavigationArrow(1)">
      <span
        ><svg width="61" height="28" viewBox="0 0 61 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M50.5303 14.5303C50.8232 14.2374 50.8232 13.7626 50.5303 13.4697L45.7574 8.6967C45.4645 8.40381 44.9896 8.40381 44.6967 8.6967C44.4038 8.98959 44.4038 9.46447 44.6967 9.75736L48.9393 14L44.6967 18.2426C44.4038 18.5355 44.4038 19.0104 44.6967 19.3033C44.9896 19.5962 45.4645 19.5962 45.7574 19.3033L50.5303 14.5303ZM0 14.75H50V13.25H0V14.75Z"
            fill="#BFA87E"
          />
          <circle cx="47.5" cy="14" r="13" stroke="#BFA87E" stroke-opacity="0.5" />
        </svg>
      </span>
    </div>
  </div>
</template>

<script>
import { ComponentMixin } from '~/mixins/component.mixin';
import { BlogsMixin } from '~/units/blogs/mixins/blogs.mixin';

export default defineNuxtComponent({
  name: 'LibraryPagination',

  mixins: [ComponentMixin, BlogsMixin],

  props: {
    version: { required: false, type: String, default: 'v1' },

    paginationActiveBg: { required: false, type: String, default: 'var(--c-secondary);' },

    paginationBg: { required: false, type: String, default: 'var(--white);' },

    isPaginationArrow: { required: false, type: Boolean, default: false },
  },

  methods: {
    getPages(activePage) {
      return activePage >= 6 ? this.pages.slice(5, 8) : this.pages.slice(activePage - 1, activePage + 2);
    },

    getPagesV2(activePage) {
      const total = this.pages.length;
      const pages = [];

      // Always show first page
      pages.push(this.pages[0]);

      // Middle pages logic
      let start = Math.max(2, activePage - 1);
      let end = Math.min(total - 1, activePage + 1);

      // Adjust if near start or end
      if (activePage <= 3) {
        start = 2;
        end = Math.min(4, total - 1);
      }
      if (activePage >= total - 2) {
        start = Math.max(total - 3, 2);
        end = total - 1;
      }

      // Add ellipsis if needed after first page
      if (start > 2) {
        pages.push({ id: 'start-ellipsis', title: '...', is_clickable: false });
      }

      // Add middle pages
      for (let i = start; i <= end; i++) {
        pages.push(this.pages[i - 1]);
      }

      // Add ellipsis if needed before last page
      if (end < total - 1) {
        pages.push({ id: 'end-ellipsis', title: '...', is_clickable: false });
      }

      // Always show last page if more than one page
      if (total > 1) {
        pages.push(this.pages[total - 1]);
      }

      return pages;
    },
  },
});
</script>
